/*
    Controller to launch the dialog used to edit a deployment
*/

import Radio from 'backbone.radio';
import EditDeploymentDialog from '@/views/dialogs/edit_deployment';

    export default function show_edit_deployment_settings(deployment, options) {
        var globalCh = Radio.channel('global');

        var edit_deployment_dialog = new EditDeploymentDialog({
            model: deployment,
            options: options
        });

        globalCh.request('showDialog', edit_deployment_dialog);
        
    }

